<div
  [ngClass]="
    FrontVersion === UserOpsVersion && UserOpsVersion === MeterOpsVersion
      ? 'valid'
      : 'invalid'
  "
>
  <span class="version-text"
    >Front version: <b>{{ FrontVersion }}</b></span
  >
  <span class="version-text"
    >UserOpsVersion version: <b>{{ UserOpsVersion }}</b></span
  >
  <span class="version-text"
    >MeterOpsVersion version: <b> {{ MeterOpsVersion }}</b></span
  >
</div>
